(function () {
  if (window.__freeGiftLoaded) return;
  window.__freeGiftLoaded = true;

  // ================== CONFIG ==================
  const GIFT_HANDLE = 'free-ceramic-diya-set-of-4';
  const MIN_CART_VALUE = 99900; // ₹999 paise me
  // ============================================

  const origFetch = window.fetch.bind(window);
  const CART_URL_RE = /\/cart\/(add|change|update|clear)/;
  let giftVariantId = null;
  let chain = Promise.resolve();

  function json(url) {
    return origFetch(url).then(function (r) { return r.json(); });
  }

  function post(url, body) {
    return origFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  async function getGiftVariantId() {
    if (giftVariantId) return giftVariantId;
    const res = await origFetch('/products/' + GIFT_HANDLE + '.js');
    if (!res.ok) {
      console.warn('[FreeGift] Gift product nahi mila (status ' + res.status + '). Published/Online Store check karo.');
      return null;
    }
    const product = await res.json();
    const v = product.variants.find(function (v) { return v.available; }) || null;
    giftVariantId = v ? v.id : null;
    return giftVariantId;
  }

  // ---------- Gift rule (true = cart badla) ----------
  async function doCheck() {
    try {
      const id = await getGiftVariantId();
      if (!id) {
        console.warn('[FreeGift] Gift variant available nahi hai (stock/published check karo)');
        return false;
      }

      const cart = await json('/cart.js?t=' + Date.now());
      const gift = cart.items.find(function (i) { return i.variant_id === id; });
      const others = cart.items.filter(function (i) { return i.variant_id !== id; });
      const paidTotal = others.reduce(function (s, i) { return s + i.original_line_price; }, 0);

      // Gift tabhi rahega jab main product ho AND value 999 se upar ho
      const eligible = others.length > 0 && paidTotal > MIN_CART_VALUE;

      console.log('[FreeGift] paidTotal:', paidTotal, 'eligible:', eligible, 'giftInCart:', !!gift);

      if (eligible) {
        if (!gift) {
          const r = await post('/cart/add.js', { items: [{ id: id, quantity: 1 }] });
          if (!r.ok) {
            console.error('[FreeGift] Add fail:', r.status, await r.text());
            giftVariantId = null; // agli baar variant dobara check ho
            return false;
          }
          return true;
        }
        if (gift.quantity > 1) {
          await post('/cart/change.js', { id: gift.key, quantity: 1 }); // max 1
          return true;
        }
      } else if (gift) {
        await post('/cart/change.js', { id: gift.key, quantity: 0 });
        return true;
      }
    } catch (e) {
      console.error('[FreeGift] Error', e);
    }
    return false;
  }

  // Saari checks line me chalti hain
  function runCheck() {
    const p = chain.then(doCheck, doCheck);
    chain = p.catch(function () {});
    return p;
  }

  // ---------- Request se sections ki info ----------
  function getReq(args) {
    let sections = null, sUrl = null;
    try {
      const body = args[1] && args[1].body;
      if (typeof body === 'string') {
        try {
          const j = JSON.parse(body);
          sections = j.sections; sUrl = j.sections_url;
        } catch (e) {
          const p = new URLSearchParams(body);
          sections = p.get('sections'); sUrl = p.get('sections_url');
        }
      } else if (body instanceof FormData || body instanceof URLSearchParams) {
        sections = body.get('sections'); sUrl = body.get('sections_url');
      }
    } catch (e) {}
    if (Array.isArray(sections)) sections = sections.join(',');
    return { sections: sections, sUrl: sUrl };
  }

  // ---------- fetch hook: theme ko gift ke saath sahi response do ----------
  window.fetch = async function () {
    const args = arguments;
    const res = await origFetch.apply(window, args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';

    if (!CART_URL_RE.test(url) || !res.ok) return res;

    try {
      const changed = await runCheck();
      if (!changed) return res;

      const data = await res.clone().json();
      const req = getReq(args);

      // Fresh cart sections (gift ke saath)
      if (req.sections) {
        const base = req.sUrl || '/';
        const sep = base.indexOf('?') > -1 ? '&' : '?';
        data.sections = await json(base + sep + 'sections=' + encodeURIComponent(req.sections) + '&t=' + Date.now());
      }

      // change/update/clear response me poora cart hota hai, use fresh karo
      if (/\/cart\/(change|update|clear)/.test(url)) {
        const fresh = await json('/cart.js?t=' + Date.now());
        Object.keys(fresh).forEach(function (k) { data[k] = fresh[k]; });
      }

      return new Response(JSON.stringify(data), {
        status: res.status,
        statusText: res.statusText,
        headers: new Headers({ 'Content-Type': 'application/json' })
      });
    } catch (e) {
      console.error('[FreeGift] Response error', e);
      return res;
    }
  };

  // ---------- Backup: cart UI manually refresh ----------
  function htmlFrom(sectionHtml, selector) {
    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  async function refreshCartUI() {
    const cart = await json('/cart.js?t=' + Date.now());
    const drawer = document.querySelector('cart-drawer');
    const cartItems = document.querySelector('cart-items');
    const footer = document.getElementById('main-cart-footer');

    const ids = ['cart-icon-bubble'];
    if (drawer) ids.push('cart-drawer');
    const data = await json('/?sections=' + ids.join(',') + '&t=' + Date.now());

    if (drawer && data['cart-drawer']) {
      const inner = drawer.querySelector('.drawer__inner');
      const html = htmlFrom(data['cart-drawer'], '.drawer__inner');
      if (inner && html !== null) inner.innerHTML = html;
      drawer.classList.toggle('is-empty', cart.item_count === 0);
    }

    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && data['cart-icon-bubble']) {
      const html = htmlFrom(data['cart-icon-bubble'], '.shopify-section');
      if (html !== null) bubble.innerHTML = html;
    }

    if (cartItems && cartItems.dataset.id) {
      const html = await origFetch('/?section_id=' + cartItems.dataset.id + '&t=' + Date.now())
        .then(function (r) { return r.text(); });
      const inner = htmlFrom(html, '.js-contents');
      const target = cartItems.querySelector('.js-contents') || cartItems;
      if (inner !== null) target.innerHTML = inner;
    }

    if (footer && footer.dataset.id) {
      const html = await origFetch('/?section_id=' + footer.dataset.id + '&t=' + Date.now())
        .then(function (r) { return r.text(); });
      const inner = htmlFrom(html, '.js-contents');
      const target = footer.querySelector('.js-contents') || footer;
      if (inner !== null) target.innerHTML = inner;
    }

    lockGiftRows();
  }

  function backgroundCheck() {
    runCheck().then(function (changed) {
      if (changed) return refreshCartUI();
    });
  }

  // XHR se cart change (agar theme use kare)
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && CART_URL_RE.test(url)) {
      this.addEventListener('loadend', function () { setTimeout(backgroundCheck, 100); });
    }
    return origOpen.apply(this, arguments);
  };

  // Safety net
  setInterval(function () { if (!document.hidden) backgroundCheck(); }, 3000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) backgroundCheck(); });
  document.addEventListener('DOMContentLoaded', backgroundCheck);

  // ---------- Gift line lock: customer remove / quantity change na kar sake ----------
  const ROW_SELECTOR = '.cart-item, tr.cart-item, [id^="CartItem-"], [id^="CartDrawer-Item-"]';

  function isGiftRow(el) {
    const row = el.closest(ROW_SELECTOR);
    return row && row.querySelector('a[href*="' + GIFT_HANDLE + '"]') ? row : null;
  }

  function lockGiftRows() {
    document.querySelectorAll('a[href*="' + GIFT_HANDLE + '"]').forEach(function (link) {
      const row = link.closest(ROW_SELECTOR);
      if (!row || row.dataset.giftLocked) return;
      row.dataset.giftLocked = '1';

      row.querySelectorAll('cart-remove-button, .cart-item__quantity, quantity-input, .quantity, [name="updates[]"]')
        .forEach(function (el) { el.style.display = 'none'; });

      const nameCell = row.querySelector('.cart-item__details') || link.parentElement;
      if (nameCell && !nameCell.querySelector('.free-gift-badge')) {
        const badge = document.createElement('div');
        badge.className = 'free-gift-badge';
        badge.textContent = '🎁 Free Gift';
        badge.style.cssText = 'color:#2e7d32;font-weight:600;margin-top:4px;';
        nameCell.appendChild(badge);
      }
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('cart-remove-button, .cart-remove-button, a[href*="/cart/change"]');
    if (btn && isGiftRow(btn)) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('change', function (e) {
    if (e.target.matches('input[name="updates[]"], quantity-input input') && isGiftRow(e.target)) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      e.target.value = 1;
    }
  }, true);

  new MutationObserver(lockGiftRows).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', lockGiftRows);
})();